export const b2cPolicies = {
    names: {
        signUpSignIn: "B2C_1A_SEIU_SIGNUP_SIGNIN_MSAL3",
        forgotPassword: "B2C_1A_SEIU_PASSWORDRESET_SIGNIN_MSAL3",
    },
    authorities: {
        signUpSignIn: {
            authority: "https://seiu1021b2c.b2clogin.com/seiu1021b2c.onmicrosoft.com/B2C_1A_SEIU_SIGNUP_SIGNIN_MSAL3",
        },
        forgotPassword: {
            authority: "https://seiu1021b2c.b2clogin.com/seiu1021b2c.onmicrosoft.com/B2C_1A_SEIU_PASSWORDRESET_SIGNIN_MSAL3",
        },
    },
    authorityDomain: "seiu1021b2c.b2clogin.com",
};